// ** UI
import Box from '@mui/material/Box';

type LightboxDotsProps = {
	count: number;
	activeIndex: number;
};

const LightboxDots = ({ count, activeIndex }: LightboxDotsProps) => {
	if (count <= 1) return null;

	return (
		<Box
			aria-hidden="true"
			sx={{
				display: { xs: 'flex', md: 'none' },
				justifyContent: 'center',
				gap: '0.5rem',
				mt: '1.5rem'
			}}
		>
			{Array.from({ length: count }, (_, i) => `dot-${i}`).map((dotKey, i) => (
				<Box
					key={dotKey}
					sx={{
						width: 8,
						height: 8,
						borderRadius: '2px',
						bgcolor: i === activeIndex ? 'common.white' : 'softGrey.main',
						transition: 'background-color 0.2s ease, opacity 0.2s ease'
					}}
				/>
			))}
		</Box>
	);
};

export default LightboxDots;
